var _ellipse, _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcaseEmptyScreenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 171,
    viewBox: "0 0 172 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.8278,
    cy: 85.44,
    rx: 85.8278,
    ry: 85.44,
    fill: "#E0EDF0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 62C45 56.4772 49.4772 52 55 52H128C133.523 52 138 56.4772 138 62V116C138 121.523 133.523 126 128 126H55C49.4772 126 45 121.523 45 116V62Z",
    fill: "#A4E0E0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 87,
    r: 4,
    fill: "#E0EDF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71 45V38C71 30.8203 76.8203 25 84 25H106C113.18 25 119 30.8203 119 38V44.5652",
    stroke: "#A4E0E0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141 93.1579C124.17 99.9706 105.773 103.722 86.5 103.722C67.227 103.722 48.8302 99.9706 32 93.1579M110.722 49.2222V37.1111C110.722 30.4223 105.3 25 98.6111 25H74.3889C67.7001 25 62.2778 30.4223 62.2778 37.1111V49.2222M86.5 85.5556H86.5605M44.1111 134H128.889C135.578 134 141 128.578 141 121.889V61.3333C141 54.6446 135.578 49.2222 128.889 49.2222H44.1111C37.4223 49.2222 32 54.6446 32 61.3333V121.889C32 128.578 37.4223 134 44.1111 134Z",
    stroke: "#0B8397",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseEmptyScreenIcon);
export default __webpack_public_path__ + "static/media/briefcase-empty-screen-icon.15862244e12e18a6c5a4163af2c2da6e.svg";
export { ForwardRef as ReactComponent };